var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1723,
    height: 446,
    viewBox: "0 0 1723 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_3005_59)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.435 320.067C132.566 342.101 131.124 341.271 118.241 355.029C122.705 344.129 120.799 333.636 121.163 319.702L114.76 327.553C111.239 314.181 106.882 308.596 96.8874 300.421L91.5139 308.77C82.1111 293.98 77.6086 286.208 75.9233 269.888L72.7735 277.976C72.7735 277.976 43.2341 236.768 47.3604 209.891C49.9614 192.949 54.1132 181.026 66.9823 172.381C65.4125 162.442 37.1645 163.391 46.4164 156.421C55.6682 149.45 69.6621 170.703 69.6621 170.703C84.7462 161.913 98.6609 164.733 116.074 172.299C145.294 184.995 159.336 238.666 163.132 248.695C171.845 271.717 152.414 324.561 152.414 324.561C152.414 324.561 150.303 298.033 141.435 320.067Z",
    fill: "url(#paint0_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.659 55.2211C421.246 24.697 423.294 26.1609 449.388 8.39989C438.091 23.4861 437.341 39.1052 431.618 59.3344L444.961 49.0305C445.788 69.1278 450.846 78.0317 464.155 91.7043L476 80.4942C485.908 103.697 490.398 115.811 487.144 139.876L495.262 128.655C495.262 128.655 528.323 193.889 511.696 232.304C501.216 256.518 490.05 273.15 465.859 283.467C464.765 298.219 511.23 301.828 493.561 310.346C475.892 318.863 460.867 285.438 460.867 285.438C433.007 295.574 411.328 289.009 385.685 274.913C342.654 251.259 339.479 170.612 336.973 155.335C331.22 120.266 382.389 46.7363 382.389 46.7363C382.389 46.7363 376.072 85.7452 398.659 55.2211Z",
    fill: "url(#paint1_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.242 159.475C139.141 151.878 120.628 112.904 120.628 112.904C120.628 112.904 152.416 155.016 166.005 139.29C174.023 130.01 168.937 108.423 168.937 108.423C187.079 144.904 208.472 202.441 215.392 201.839C222.312 201.237 223.692 170.804 223.692 170.804L225.3 126.425C225.3 126.425 231.507 133.706 236.347 134.42C241.187 135.133 273.395 100.113 273.395 100.113C273.395 100.113 271.918 140.664 285.485 136.998C299.052 133.333 303.229 127.291 303.229 127.291C306.08 127.297 290.356 181.391 290.356 181.391C290.356 181.391 267.425 219.317 260.945 229.263C268.994 222.911 302.879 223.829 299.043 229.43C299.043 229.43 279.272 237.281 279.743 239.989C280.213 242.697 310.778 247.923 310.778 247.923C310.778 247.923 284.759 266.903 285.69 271.93C286.62 276.957 301.808 283.28 301.808 283.28C301.808 283.28 257.108 282.805 231.04 296.242C231.04 296.242 258.843 343.743 261.281 351.52C263.719 359.298 264.151 363.791 264.151 363.791C264.151 363.791 263.293 384.032 255.174 384.717C247.055 385.402 254.027 363.275 250.751 350.756C245.111 329.199 224.361 300.299 224.361 300.299C201.061 316.796 181.115 355.438 181.115 355.438C181.115 355.438 179.989 334.897 175.016 335.048C170.042 335.198 147.118 354.66 147.118 354.66C147.118 354.66 149.783 325.521 147.423 323.055C145.063 320.59 129.965 328.849 129.965 328.849C129.965 328.849 145.273 296.946 141.722 297.109C138.171 297.272 104.158 300.079 82.8617 291.545C68.6417 285.847 50.0346 270.355 50.0346 270.355C50.0346 270.355 66.1534 267.309 70.1133 259.37C76.6367 246.293 43.0235 234.251 43.0235 234.251C43.0235 234.251 79.7404 241.288 86.5508 225.465C89.5553 218.485 87.1193 206.173 87.1193 206.173C107.851 226.983 122.566 235.359 153.932 244.755C135.484 207.143 122.312 187.643 94.6272 155.205C94.6272 155.205 112.206 163.986 122.242 159.475Z",
    fill: "url(#paint2_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.673 312.267C270.667 313.067 258.439 335.618 273.405 342.378C289.595 349.692 293.856 318.767 300.336 319.005C303.87 319.134 309.179 332.634 320.048 329.474C332.09 325.972 318.358 304.863 328.978 298.197C335.425 294.15 344.098 323.582 359.93 324.408C380.631 325.488 338.964 257.198 358.62 253.126C372.084 250.337 381.664 280.6 400.84 277.885C423.13 274.73 353.943 196.442 378.99 196.561C390.161 196.615 399.514 212.51 406.148 206.89C413.651 200.533 409.232 184.905 401.984 174.328C397.391 167.626 381.587 153.936 380.932 146.094C379.316 126.776 369.853 110.264 352.338 103.655C352.297 103.64 352.256 103.624 352.214 103.609C350.62 102.265 365.536 72.4003 356.001 69.7869C349.813 68.0908 350.76 102.213 345.457 101.717C326.212 98.3932 307.941 114.117 300.028 121.154C288.912 131.04 260.736 129.59 264.14 144.069C265.759 150.958 276.115 148.42 277.148 155.421C278.973 167.796 228.859 177.938 237.778 204.624C245.851 228.776 263.505 213.894 264.708 217.576C268.388 228.839 228.268 236.805 234.496 253.637C242.968 276.534 259.287 259.115 263.765 271.949C267.324 282.15 232.038 288.556 243.623 309.581C249.5 320.246 262.679 311.468 266.673 312.267Z",
    fill: "url(#paint3_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.004 253.08C531.103 272.339 529.903 271.187 514.093 281.448C521.043 271.939 521.714 261.295 525.414 247.857L517.313 253.941C517.107 240.115 514.219 233.646 506.48 223.31L499.258 230.124C493.683 213.508 491.179 204.882 493.463 188.636L488.463 195.73C488.463 195.73 469.685 148.633 480.146 123.534C486.74 107.713 493.634 97.1363 508.203 91.8351C509.066 81.8102 481.417 75.9469 492.072 71.4024C502.727 66.858 511.207 90.8499 511.207 90.8499C527.961 85.9403 540.791 92.0195 555.877 103.547C581.193 122.889 581.933 178.362 583.209 189.008C586.138 213.449 554.583 260.079 554.583 260.079C554.583 260.079 558.906 233.821 545.004 253.08Z",
    fill: "url(#paint4_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1318.39 299.398C1304.48 318.658 1303.28 317.505 1287.47 327.766C1294.43 318.258 1295.1 307.614 1298.8 294.175L1290.69 300.259C1290.49 286.433 1287.6 279.965 1279.86 269.628L1272.64 276.442C1267.06 259.826 1264.56 251.2 1266.84 234.954L1261.84 242.048C1261.84 242.048 1243.07 194.952 1253.53 169.853C1260.12 154.032 1267.02 143.455 1281.58 138.153C1282.45 128.129 1254.8 122.265 1265.45 117.721C1276.11 113.176 1284.59 137.168 1284.59 137.168C1301.34 132.259 1314.17 138.338 1329.26 149.865C1354.57 169.208 1355.32 224.68 1356.59 235.327C1359.52 259.768 1327.96 306.398 1327.96 306.398C1327.96 306.398 1332.29 280.139 1318.39 299.398Z",
    fill: "url(#paint5_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.31 57.767C887.568 33.5614 889.204 35.4744 918.8 24.5006C904.21 36.4318 899.731 51.4135 889.317 69.676L904.743 62.8784C900.72 82.5862 903.491 92.4443 913.127 108.913L927.317 100.876C931.362 125.779 932.812 138.617 923.873 161.197L934.449 152.253C934.449 152.253 950.873 223.519 925.507 256.816C909.517 277.804 894.684 291.267 868.724 295.472C864.118 309.53 908.356 324.193 889.159 328.217C869.961 332.242 863.404 296.186 863.404 296.186C833.925 299.334 814.458 287.754 792.95 267.912C756.86 234.615 773.148 155.566 774.385 140.135C777.223 104.71 844.554 45.6227 844.554 45.6227C844.554 45.6227 829.053 81.9726 858.31 57.767Z",
    fill: "url(#paint6_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.945 92.5787C583.173 89.2635 574.563 46.984 574.563 46.984C574.563 46.984 595.307 95.4982 612.275 83.4957C622.287 76.4133 622.535 54.2365 622.535 54.2365C631.383 94.0073 638.331 154.998 645.193 156.076C652.055 157.154 660.704 127.943 660.704 127.943L672.924 85.2494C672.924 85.2494 677.201 93.8081 681.727 95.6632C686.254 97.5184 725.931 71.2592 725.931 71.2592C725.931 71.2592 714.758 110.268 728.808 109.968C742.858 109.669 748.364 104.807 748.364 104.807C751.13 105.497 722.874 154.231 722.874 154.231C722.874 154.231 691.505 185.54 682.826 193.638C692.165 189.405 724.838 198.435 719.769 202.951C719.769 202.951 698.691 205.823 698.497 208.565C698.304 211.307 726.719 223.721 726.719 223.721C726.719 223.721 696.903 235.896 696.599 241C696.294 246.103 709.519 255.888 709.519 255.888C709.519 255.888 666.241 244.691 637.709 251.474C637.709 251.474 653.289 304.262 653.788 312.398C654.287 320.533 653.628 324.998 653.628 324.998C653.628 324.998 647.933 344.441 639.887 343.156C631.841 341.871 643.923 322.066 643.75 309.127C643.453 286.846 630.251 253.808 630.251 253.808C603.671 264.226 575.028 296.946 575.028 296.946C575.028 296.946 578.869 276.736 574.005 275.688C569.141 274.639 542.213 288.025 542.213 288.025C542.213 288.025 551.798 260.379 550.1 257.419C548.401 254.459 531.761 258.851 531.761 258.851C531.761 258.851 554.284 231.558 550.798 230.863C547.311 230.168 513.62 224.724 494.996 211.325C482.561 202.378 468.22 182.871 468.22 182.871C468.22 182.871 484.598 183.785 490.349 177.03C499.822 165.902 470.085 146.139 470.085 146.139C470.085 146.139 504.037 161.789 514.449 148.065C519.042 142.011 519.634 129.474 519.634 129.474C534.761 154.654 547.034 166.32 575.224 182.975C566.35 142.032 558.248 119.939 539.164 81.8018C539.164 81.8018 554.119 94.5477 564.945 92.5787Z",
    fill: "url(#paint7_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.451 275.588C672.136 277.324 654.85 296.278 667.753 306.435C681.712 317.423 693.276 288.427 699.51 290.214C702.91 291.188 704.821 305.568 716.13 305.111C728.661 304.604 720.401 280.815 732.311 276.894C739.542 274.514 740.892 305.168 756.061 309.772C775.897 315.792 751.852 239.494 771.91 240.262C785.651 240.788 787.682 272.466 806.948 274.437C829.344 276.728 780.985 184.114 805.27 190.246C816.101 192.981 821.363 210.657 829.152 206.795C837.962 202.426 837.427 186.194 832.931 174.185C830.083 166.577 818.029 149.492 819.276 141.722C822.347 122.581 817.128 104.28 801.712 93.6578C801.676 93.6328 801.64 93.6079 801.604 93.583C800.378 91.8957 822.031 66.4877 813.403 61.6607C807.803 58.5279 800.527 91.8788 795.498 90.1239C777.616 82.2749 756.103 93.1501 746.731 98.0807C733.566 105.007 706.563 96.8319 706.389 111.706C706.307 118.782 716.969 118.805 716.29 125.849C715.09 138.3 664.007 136.109 666.256 164.156C668.291 189.54 689.003 179.333 689.286 183.197C690.153 195.014 649.295 193.111 651.298 210.946C654.022 235.208 674.047 222.218 675.311 235.752C676.316 246.509 640.524 244.253 646.72 267.445C649.863 279.209 664.766 273.853 668.451 275.588Z",
    fill: "url(#paint8_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1622 74.2441C1651.26 50.0384 1652.89 51.9515 1682.49 40.9776C1667.9 52.9089 1663.42 67.8905 1653 86.1531L1668.43 79.3555C1664.41 99.0632 1667.18 108.921 1676.81 125.39L1691 117.353C1695.05 142.256 1696.5 155.094 1687.56 177.674L1698.14 168.73C1698.14 168.73 1714.56 239.996 1689.19 273.293C1673.21 294.281 1658.37 307.744 1632.41 311.949C1627.81 326.007 1672.04 340.67 1652.85 344.694C1633.65 348.719 1627.09 312.663 1627.09 312.663C1597.61 315.811 1578.15 304.231 1556.64 284.389C1520.55 251.092 1536.84 172.043 1538.07 156.612C1540.91 121.187 1608.24 62.0998 1608.24 62.0998C1608.24 62.0998 1592.74 98.4497 1622 74.2441Z",
    fill: "url(#paint9_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1328.63 109.056C1346.86 105.741 1338.25 63.461 1338.25 63.461C1338.25 63.461 1358.99 111.975 1375.96 99.9727C1385.97 92.8903 1386.22 70.7135 1386.22 70.7135C1395.07 110.484 1402.02 171.475 1408.88 172.553C1415.74 173.631 1424.39 144.42 1424.39 144.42L1436.61 101.726C1436.61 101.726 1440.89 110.285 1445.42 112.14C1449.94 113.995 1489.62 87.7363 1489.62 87.7363C1489.62 87.7363 1478.45 126.745 1492.5 126.445C1506.55 126.146 1512.05 121.284 1512.05 121.284C1514.82 121.974 1486.56 170.708 1486.56 170.708C1486.56 170.708 1455.19 202.017 1446.51 210.115C1455.85 205.882 1488.53 214.912 1483.46 219.428C1483.46 219.428 1462.38 222.3 1462.19 225.042C1461.99 227.784 1490.41 240.198 1490.41 240.198C1490.41 240.198 1460.59 252.373 1460.29 257.477C1459.98 262.58 1473.21 272.365 1473.21 272.365C1473.21 272.365 1429.93 261.168 1401.4 267.951C1401.4 267.951 1416.98 320.739 1417.48 328.875C1417.98 337.01 1417.32 341.475 1417.32 341.475C1417.32 341.475 1411.62 360.918 1403.58 359.633C1395.53 358.348 1407.61 338.543 1407.44 325.604C1407.14 303.323 1393.94 270.285 1393.94 270.285C1367.36 280.703 1338.72 313.423 1338.72 313.423C1338.72 313.423 1342.56 293.213 1337.69 292.165C1332.83 291.116 1305.9 304.502 1305.9 304.502C1305.9 304.502 1315.49 276.856 1313.79 273.896C1312.09 270.936 1295.45 275.328 1295.45 275.328C1295.45 275.328 1317.97 248.035 1314.49 247.34C1311 246.646 1277.31 241.201 1258.68 227.802C1246.25 218.855 1231.91 199.348 1231.91 199.348C1231.91 199.348 1248.29 200.263 1254.04 193.507C1263.51 182.379 1233.77 162.617 1233.77 162.617C1233.77 162.617 1267.73 178.266 1278.14 164.542C1282.73 158.488 1283.32 145.951 1283.32 145.951C1298.45 171.131 1310.72 182.797 1338.91 199.452C1330.04 158.509 1321.94 136.416 1302.85 98.2789C1302.85 98.2789 1317.81 111.025 1328.63 109.056Z",
    fill: "url(#paint10_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.633 89.0558C940.861 85.7405 932.251 43.461 932.251 43.461C932.251 43.461 952.995 91.9753 969.963 79.9727C979.975 72.8903 980.223 50.7135 980.223 50.7135C989.071 90.4844 996.019 151.475 1002.88 152.553C1009.74 153.631 1018.39 124.42 1018.39 124.42L1030.61 81.7264C1030.61 81.7264 1034.89 90.2851 1039.42 92.1403C1043.94 93.9954 1083.62 67.7363 1083.62 67.7363C1083.62 67.7363 1072.45 106.745 1086.5 106.445C1100.55 106.146 1106.05 101.284 1106.05 101.284C1108.82 101.974 1080.56 150.708 1080.56 150.708C1080.56 150.708 1049.19 182.017 1040.51 190.115C1049.85 185.882 1082.53 194.912 1077.46 199.428C1077.46 199.428 1056.38 202.3 1056.19 205.042C1055.99 207.784 1084.41 220.198 1084.41 220.198C1084.41 220.198 1054.59 232.373 1054.29 237.477C1053.98 242.58 1067.21 252.365 1067.21 252.365C1067.21 252.365 1023.93 241.168 995.397 247.951C995.397 247.951 1010.98 300.739 1011.48 308.875C1011.98 317.01 1011.32 321.475 1011.32 321.475C1011.32 321.475 1005.62 340.918 997.575 339.633C989.529 338.348 1001.61 318.543 1001.44 305.604C1001.14 283.323 987.939 250.285 987.939 250.285C961.359 260.703 932.716 293.423 932.716 293.423C932.716 293.423 936.557 273.213 931.693 272.165C926.829 271.116 899.901 284.502 899.901 284.502C899.901 284.502 909.486 256.856 907.788 253.896C906.089 250.936 889.449 255.328 889.449 255.328C889.449 255.328 911.972 228.035 908.486 227.34C904.999 226.646 871.308 221.201 852.684 207.802C840.249 198.855 825.908 179.348 825.908 179.348C825.908 179.348 842.286 180.263 848.037 173.507C857.51 162.379 827.773 142.617 827.773 142.617C827.773 142.617 861.725 158.266 872.137 144.542C876.73 138.488 877.322 125.951 877.322 125.951C892.449 151.131 904.722 162.797 932.912 179.452C924.038 138.509 915.936 116.416 896.852 78.2789C896.852 78.2789 911.807 91.0247 922.633 89.0558Z",
    fill: "url(#paint11_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1432.14 292.066C1435.82 293.801 1418.54 312.755 1431.44 322.912C1445.4 333.901 1456.96 304.904 1463.2 306.691C1466.6 307.666 1468.51 322.046 1479.82 321.588C1492.35 321.081 1484.09 297.292 1496 293.372C1503.23 290.991 1504.58 321.645 1519.75 326.249C1539.59 332.27 1515.54 255.971 1535.6 256.739C1549.34 257.266 1551.37 288.944 1570.64 290.914C1593.03 293.205 1544.67 200.591 1568.96 206.723C1579.79 209.458 1585.05 227.135 1592.84 223.272C1601.65 218.904 1601.11 202.672 1596.62 190.663C1593.77 183.054 1581.72 165.969 1582.96 158.2C1586.04 139.059 1580.82 120.758 1565.4 110.135C1565.36 110.11 1565.33 110.085 1565.29 110.06C1564.07 108.373 1585.72 82.965 1577.09 78.138C1571.49 75.0052 1564.21 108.356 1559.19 106.601C1541.3 98.7522 1519.79 109.627 1510.42 114.558C1497.25 121.484 1470.25 113.309 1470.08 128.183C1469.99 135.259 1480.66 135.283 1479.98 142.327C1478.78 154.777 1427.69 152.586 1429.94 180.633C1431.98 206.017 1452.69 195.811 1452.97 199.674C1453.84 211.491 1412.98 209.588 1414.99 227.423C1417.71 251.685 1437.74 238.695 1439 252.229C1440 262.987 1404.21 260.73 1410.41 283.922C1413.55 295.686 1428.45 290.33 1432.14 292.066Z",
    fill: "url(#paint12_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1206.43 66.6447C1235.69 42.439 1237.32 44.3521 1266.92 33.3783C1252.33 45.3095 1247.85 60.2912 1237.44 78.5537L1252.86 71.7561C1248.84 91.4639 1251.61 101.322 1261.25 117.791L1275.44 109.754C1279.48 134.657 1280.93 147.495 1271.99 170.074L1282.57 161.131C1282.57 161.131 1298.99 232.396 1273.63 265.694C1257.64 286.682 1242.8 300.145 1216.84 304.35C1212.24 318.407 1256.47 333.071 1237.28 337.095C1218.08 341.119 1211.52 305.063 1211.52 305.063C1182.04 308.212 1162.58 296.632 1141.07 276.789C1104.98 243.493 1121.27 164.444 1122.5 149.012C1125.34 113.588 1192.67 54.5004 1192.67 54.5004C1192.67 54.5004 1177.17 90.8503 1206.43 66.6447Z",
    fill: "url(#paint13_linear_3005_59)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_df_3005_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1016.57 284.466C1020.25 286.201 1002.97 305.156 1015.87 315.313C1029.83 326.301 1041.4 297.305 1047.63 299.091C1051.03 300.066 1052.94 314.446 1064.25 313.989C1076.78 313.482 1068.52 289.693 1080.43 285.772C1087.66 283.392 1089.01 314.046 1104.18 318.65C1124.02 324.67 1099.97 248.372 1120.03 249.14C1133.77 249.666 1135.8 281.344 1155.07 283.315C1177.46 285.606 1129.1 192.991 1153.39 199.124C1164.22 201.859 1169.48 219.535 1177.27 215.673C1186.08 211.304 1185.55 195.072 1181.05 183.063C1178.2 175.455 1166.15 158.369 1167.39 150.6C1170.47 131.459 1165.25 113.158 1149.83 102.536C1149.79 102.511 1149.76 102.486 1149.72 102.461C1148.5 100.774 1170.15 75.3656 1161.52 70.5386C1155.92 67.4058 1148.65 100.757 1143.62 99.0018C1125.73 91.1528 1104.22 102.028 1094.85 106.959C1081.68 113.885 1054.68 105.71 1054.51 120.584C1054.43 127.66 1065.09 127.683 1064.41 134.727C1063.21 147.178 1012.13 144.987 1014.37 173.034C1016.41 198.418 1037.12 188.211 1037.4 192.075C1038.27 203.892 997.414 201.988 999.416 219.824C1002.14 244.086 1022.17 231.096 1023.43 244.63C1024.43 255.387 988.643 253.131 994.839 276.323C997.982 288.087 1012.88 282.731 1016.57 284.466Z",
    fill: "url(#paint14_linear_3005_59)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3005_59",
    x: 39.0234,
    y: 4.3999,
    width: 1668.34,
    height: 384.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_3005_59",
    x: 36.1596,
    y: 135.417,
    width: 148.82,
    height: 228.012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: -5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_df_3005_59",
    x: 328.122,
    y: -0.0000977516,
    width: 207.85,
    height: 331.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_df_3005_59",
    x: 31.8234,
    y: 88.9133,
    width: 298.555,
    height: 321.02,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 11.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_df_3005_59",
    x: 225.438,
    y: 61.3258,
    width: 204.203,
    height: 301.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.184314 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_df_3005_59",
    x: 468.576,
    y: 51.2296,
    width: 134.425,
    height: 238.618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: -5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_df_3005_59",
    x: 1241.96,
    y: 97.5479,
    width: 134.425,
    height: 238.618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: -5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_df_3005_59",
    x: 761.257,
    y: 16.1005,
    width: 198.021,
    height: 332.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_df_3005_59",
    x: 457.02,
    y: 35.7839,
    width: 311.134,
    height: 332.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 11.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_df_3005_59",
    x: 637.599,
    y: 53.0529,
    width: 218.108,
    height: 276.657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.184314 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_df_3005_59",
    x: 1524.94,
    y: 32.5775,
    width: 198.021,
    height: 332.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_df_3005_59",
    x: 1220.71,
    y: 52.2609,
    width: 311.134,
    height: 332.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 11.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_df_3005_59",
    x: 814.708,
    y: 32.2609,
    width: 311.134,
    height: 332.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 11.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_df_3005_59",
    x: 1401.29,
    y: 69.5302,
    width: 218.108,
    height: 276.657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.184314 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_df_3005_59",
    x: 1109.38,
    y: 24.9782,
    width: 198.021,
    height: 332.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_df_3005_59",
    x: 985.718,
    y: 61.9308,
    width: 218.108,
    height: 276.657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.184314 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3005_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3005_59",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect2_foregroundBlur_3005_59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3005_59",
    x1: 58.5103,
    y1: 149.714,
    x2: 158.719,
    y2: 332.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3005_59",
    x1: 375.158,
    y1: 33.4994,
    x2: 471.349,
    y2: 317.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3005_59",
    x1: 127.604,
    y1: 109.088,
    x2: 273.246,
    y2: 375.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3005_59",
    x1: 354.163,
    y1: 69.4146,
    x2: 298.455,
    y2: 347.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3005_59",
    x1: 505.423,
    y1: 67.7966,
    x2: 558.704,
    y2: 269.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3005_59",
    x1: 1278.8,
    y1: 114.115,
    x2: 1332.09,
    y2: 315.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3005_59",
    x1: 840.715,
    y1: 31.0368,
    x2: 865.764,
    y2: 330.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3005_59",
    x1: 582.252,
    y1: 44.9548,
    x2: 659.69,
    y2: 338.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3005_59",
    x1: 811.709,
    y1: 60.8578,
    x2: 690.78,
    y2: 317.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3005_59",
    x1: 1604.4,
    y1: 47.5138,
    x2: 1629.45,
    y2: 346.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3005_59",
    x1: 1345.94,
    y1: 61.4318,
    x2: 1423.38,
    y2: 354.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3005_59",
    x1: 939.94,
    y1: 41.4318,
    x2: 1017.38,
    y2: 334.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3005_59",
    x1: 1575.4,
    y1: 77.3351,
    x2: 1454.47,
    y2: 334.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3005_59",
    x1: 1188.83,
    y1: 39.9145,
    x2: 1213.88,
    y2: 339.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3005_59",
    x1: 1159.83,
    y1: 69.7358,
    x2: 1038.9,
    y2: 326.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLeaves);
export default __webpack_public_path__ + "static/media/footer-leaves.663779e2c3b1c9b362ece2ce043c9897.svg";
export { ForwardRef as ReactComponent };